import { DocumentReviewLayout } from '~/widgets/document-review-layout'
import { DuplicationContent } from './duplication-content'

/**
 * Duplication page — second EOB step. Captures patient info and checks for
 * duplicates in AMD before proceeding to EOB processing.
 *
 * This is a `page/` because it's a route component for `/documents/:documentKey/duplication`.
 */
export function DocumentDuplicationPage() {
  return (
    <DocumentReviewLayout step="Duplication">
      <DuplicationContent />
    </DocumentReviewLayout>
  )
}
